export default __webpack_public_path__ + "static/media/credit-card.3617cea1.svg";